import React from "react";

const PrivacyPolicy: React.FC = () => {
  const sectionStyle = { marginTop: "2rem" };
  const headingStyle = { marginBottom: "1rem" };
  const listStyle = { marginLeft: "2rem", marginTop: "1rem" };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#1C3854",
        minHeight: "100vh",
        color: "#fff",
        fontFamily: "Poppins, sans-serif",
        padding: "2rem",
        paddingTop: "calc(64px + 2rem)", // Account for navbar height
      }}
    >
      <div style={{ maxWidth: "800px", margin: "0 auto", width: "100%" }}>
        <h1 style={headingStyle}>Privacy Policy for Zuz.Giving</h1>
        <p>
          <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
        </p>

        <p>
          At Zuz.Giving, we value your privacy and are committed to protecting
          your personal information. This Privacy Policy outlines how we
          collect, use, disclose, and safeguard your information when you use
          our app and services.
        </p>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>1. Information We Collect</h2>

          <h3>Personal Information</h3>
          <p>
            We may collect personal information that you provide directly to us,
            including but not limited to:
          </p>
          <ul style={listStyle}>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>
              Payment information (processed securely through third-party
              services)
            </li>
          </ul>

          <h3 style={{ marginTop: "1.5rem" }}>Non-Personal Information</h3>
          <p>
            We also collect non-personal information automatically when you use
            our app, including:
          </p>
          <ul style={listStyle}>
            <li>Device information (e.g., device type, operating system)</li>
            <li>
              Usage data (e.g., app interactions, time spent on various
              features)
            </li>
            <li>Location data (with your consent)</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>2. How We Use Your Information</h2>
          <p>We may use your information for the following purposes:</p>
          <ul style={listStyle}>
            <li>To process donations and transactions</li>
            <li>To communicate with you about your account and our services</li>
            <li>
              To send you updates, newsletters, and promotional materials (with
              your consent)
            </li>
            <li>To improve our app and services</li>
            <li>To analyze usage trends and user behavior</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>3. Sharing Your Information</h2>
          <p>
            We do not sell your personal information. We may share your
            information with:
          </p>
          <ul style={listStyle}>
            <li>
              <strong>Service Providers:</strong> Third-party vendors who help
              us operate our app and provide services, such as payment
              processors.
            </li>
            <li>
              <strong>Legal Authorities:</strong> If required by law or to
              protect our rights, privacy, safety, or property, or that of
              others.
            </li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>4. Your Rights</h2>
          <p>
            You have the following rights regarding your personal information:
          </p>
          <ul style={listStyle}>
            <li>
              <strong>Access:</strong> You can request access to the personal
              information we hold about you.
            </li>
            <li>
              <strong>Correction:</strong> You can request that we correct any
              inaccurate or incomplete information.
            </li>
            <li>
              <strong>Deletion:</strong> You can request the deletion of your
              personal information, subject to certain exceptions.
            </li>
            <li>
              <strong>Opt-Out:</strong> You can opt out of receiving marketing
              communications at any time.
            </li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect your personal information from unauthorized access, use, or
            disclosure. However, no method of transmission over the Internet or
            method of electronic storage is 100% secure.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>6. Children's Privacy</h2>
          <p>
            Zuz.Giving is not intended for use by children under the age of 13.
            We do not knowingly collect personal information from children. If
            we become aware that we have collected personal information from a
            child, we will take steps to delete such information.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>7. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any significant changes by posting the new policy on our app
            and updating the effective date at the top of this policy. Your
            continued use of the app after changes indicates your acceptance of
            the updated policy.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>8. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy or
            our practices regarding your personal information, please contact us
            at:
          </p>
          <p style={{ marginTop: "1rem" }}>
            <strong>Zuz.Giving</strong>
            <br />
            support@zuz.giving
          </p>
        </section>

        <section
          style={{
            ...sectionStyle,
            marginTop: "3rem",
            borderTop: "1px solid rgba(255,255,255,0.1)",
            paddingTop: "2rem",
          }}
        >
          <p style={{ fontStyle: "italic" }}>
            Thank you for supporting Zuz.Giving. Your privacy is important to
            us, and we are committed to safeguarding your information.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
